const initialState = () => ({
  paginate_comments_ticket: [],
  pagination_comments_ticket: {
    total: 0,
    page: 0,
  },
})

export default initialState
